import React from 'react';
import { ModalWindow } from '@cian/ui-kit/modal';
import { Button } from '@cian/ui-kit/button';
import { CheckboxButton } from '@cian/ui-kit/checkbox';
import { DEAL_TYPE_BUTTONS, FAVORITE_ENTITY_TYPE_BUTTONS } from './buttons';
import { EEntityType, EDealType } from '../../types/filters';

import * as styles from './styles.css';

interface IDealTypeFiltersModal {
  open: boolean;
  dealType: EDealType | null;
  favoriteEntityType: EEntityType | null;
  setDealType(dealType: EDealType | null): void;
  setEntityType(entityType: EEntityType | null): void;
  accept(): void;
  reset(): void;
  closeFilter(): void;
}

export const DealTypeFiltersModal: React.FC<IDealTypeFiltersModal> = ({
  open,
  dealType,
  favoriteEntityType,
  setEntityType,
  setDealType,
  accept,
  reset,
  closeFilter,
}) => {
  return (
    <ModalWindow
      fixed
      content={
        <div className={styles['filters-container']}>
          <div className={styles['row']}>
            <span className={styles['filters-title']}>Тип сделки</span>
            <div className={styles['filters-buttons']}>
              {DEAL_TYPE_BUTTONS.map(button => (
                <span key={button.label} className={styles['chipsbox-wrapper']}>
                  <CheckboxButton
                    label={button.label}
                    value={String(button.value)}
                    checked={dealType === button.value}
                    onChange={() => setDealType(button.value)}
                  />
                </span>
              ))}
            </div>
          </div>
          <div className={styles['row']}>
            <span className={styles['filters-title']}>Вид недвижимости</span>
            <div className={styles['filters-buttons']}>
              {FAVORITE_ENTITY_TYPE_BUTTONS.map(button =>
                button.value !== EEntityType.Newbuilding ? (
                  <span key={button.label} className={styles['chipsbox-wrapper']}>
                    <CheckboxButton
                      label={button.label}
                      value={String(button.value)}
                      checked={favoriteEntityType === button.value}
                      onChange={() => setEntityType(button.value)}
                    />
                  </span>
                ) : null,
              )}
            </div>
          </div>
        </div>
      }
      footer={
        <div className={styles['footer-modal']}>
          <Button fullWidth size="M" theme="fill_secondary" onClick={reset}>
            Сбросить
          </Button>
          <Button fullWidth size="M" theme="fill_primary" onClick={accept}>
            Применить
          </Button>
        </div>
      }
      width={702}
      height={342}
      onClose={closeFilter}
      open={open}
      outside
      title="Фильтр"
    />
  );
};
